import { ClientProfile, CoachProfile, Question } from "@joonapp/web-shared"

export interface FormAlert {
  message: string
  type: "success" | "error"
}

export interface CustomErrorInterface extends Error {
  code?: string
}

export interface CoachingGroup {
  profiles: (CoachProfile | ClientProfile)[]
  date_created: string
  id: number
  type: "coaching" // TODO: Update this in types - GroupType.COACHING
  sendbird_channel_url: string
  date_inactivated: string | null
  date_reactivated: string | null
}

type QuestionType = "single_choice" | "multi_choice" | "freeform"

export interface QuestionnaireAnswersResponse {
  answers: {
    answers: {
      answer: string
      id: number
      post_answer_screen: string
      value: string
    }[]
    freeform_answer: string | null
    question: {
      id: number
      question: string
      type: QuestionType
    }
  }[]
  questionnaire: {
    id: number
    title: string
    type: string
    questions: Question[]
    display_name: string
  }
  id: number
  date_submitted: string
}

export enum CoachingSubscriptionStatus {
  EXPIRED = "expired",
  PAYING = "paying",
}

export interface CoachingSubscriptionInfo {
  active_period_end_date: string
  pause_collection_end_datetime: string | null
  num_sessions: number
  price_interval: string
  price_lookup_key: string
  price_per_seat: string
  set_to_cancel: boolean
  status: CoachingSubscriptionStatus
}

export enum Gradient {
  g100 = `linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.8) 2.83%,
          rgba(255, 255, 255, 0) 51.53%,
          rgba(255, 255, 255, 0.8) 99.81%
        ),
        #e9eafa`,
  g200 = `linear-gradient(180deg, #FFF -7.69%, rgba(255, 255, 255, 0.05) 43%, #FFF 106.65%), linear-gradient(208deg, #FAE1F2 10.1%, #F6E2EE 30.26%, #ECE5F3 41.72%, #D8E3FF 52.88%, #DBD4F8 63.41%, #CDAAFB 74.27%), #E9EAFA`,
}
